import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class InputPrefix extends BaseOption {
  static userInterfaceComponent = {
    label: "Prefix",
    component: inspectorTools.SIMPLE_INPUT,
  };

  static defaultValue = "";
}
